/** Payload from `GET /api/design` — multi-tenant branding + PWA metadata. */
export interface DesignPwaConfig {
  title: string
  description: string
  icon_url: string
}

export interface DesignLogos {
  dark_logo: string
  light_logo: string
}

export interface DesignConfig {
  logos: DesignLogos
  pwa: DesignPwaConfig
  /** Optional accent overrides from tenant branding. */
  primary_color?: string
  favicon_url?: string
}

export const DESIGN_STORAGE_KEY = 'velox.design'
